const PrivacyPage = () => {
    return (
        <div>
            <p>We care about your privacy/ Promise!</p>
        </div>
    )
}

export default PrivacyPage;